import { FC } from 'react';

import { match } from 'ts-pattern';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { ORDER_CART_ENTRY_ID, ORDER_CART_TEST_ID } from '../constants';
import { Price } from '../model';
import { CellPrice, CellPriceText, CellTitle, HboMaxIcon, HboMaxVasEntryListItem } from './entries.styles';

type HboMaxVasProps = {
    isPremium: boolean;
    hasSport: boolean;
    monthlyPrice?: Price;
};

export const HboMaxVas: FC<HboMaxVasProps> = ({ isPremium, hasSport, monthlyPrice }) => {
    const { t } = useTranslations();

    const title = match({ isPremium, hasSport })
        .with({ isPremium: true, hasSport: true }, () => t['order_cart.entry_hbo_max.title.premium_sport'])
        .with({ isPremium: true, hasSport: false }, () => t['order_cart.entry_hbo_max.title.premium'])
        .with({ isPremium: false, hasSport: true }, () => t['order_cart.entry_hbo_max.title.standard_sport'])
        .otherwise(() => t['order_cart.entry_hbo_max.title.standard']);

    return (
        <HboMaxVasEntryListItem data-test={ORDER_CART_ENTRY_ID.HBO_MAX_VAS} aria-label={title}>
            <HboMaxIcon />
            <CellTitle>{title}</CellTitle>
            {isPremium || hasSport ? (
                <CellPrice price={monthlyPrice} isMonthly={true} dataTest={ORDER_CART_TEST_ID.HBO_MAX_VAS_PRICE} />
            ) : (
                <CellPriceText data-test={ORDER_CART_TEST_ID.HBO_MAX_VAS_PRICE}>
                    {t['order_cart.entry_hbo_max.price.standard']}
                </CellPriceText>
            )}
        </HboMaxVasEntryListItem>
    );
};
